import React from 'react';
import logo from '../assets/kavumainpageimg/logo-kavu.png';
import { Link } from 'react-scroll';

const Header = ({ isScrolled, isMobileMenuOpen, toggleMobileMenu }) => (
    <>
        <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar-content">
                <div className="nav-placeholder"></div>
                <div className="logo-container">
                   <a href="/"> <img src={logo} alt="Logo" className="logo" /> </a>
                </div>
                <nav className="nav-links">
                    <Link to="page3" smooth={true} duration={500} style={{cursor: 'pointer'}}>ഐതിഹ്യം</Link>
                    <Link to="page4" smooth={true} duration={500} style={{cursor: 'pointer'}}>വഴിപാടുകൾ</Link>
                    <Link to="page5b" smooth={true} duration={500} style={{cursor: 'pointer'}}>പൂരോത്സവം</Link>
                    <Link to="page-theyyam" smooth={true} duration={500} style={{cursor: 'pointer'}}>തെയ്യം</Link>
                    <Link to="page7" aria-label="Gallery"><i className="fas fa-images"></i></Link>
<a href="whatsapp://send?phone=917907852971" aria-label="WhatsApp">
    <i className="fab fa-whatsapp"></i>
</a>                </nav>
                <div className="mobile-menu-container">
                    <Link to="page7" className="icon-link" aria-label="Gallery"><i className="fas fa-images"></i></Link>
                    <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Open Menu" aria-expanded={isMobileMenuOpen}>
                        {isMobileMenuOpen ? (
                            <i className="fas fa-times"></i> // Close icon when menu is open
                        ) : (
                            <i className="fas fa-bars"></i> // Hamburger icon when menu is closed
                        )}
                    </button>
                </div>
            </div>
        </header>
        <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
            <nav className={`mobile-nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                <button className="mobile-menu-close-btn" onClick={toggleMobileMenu} aria-label="Close Menu">×</button>
                <Link to="page3" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}>ഐതിഹ്യം</Link>
                <Link to="page4" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}>വഴിപാടുകൾ</Link>
                <Link to="page5b" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}>ഉത്സവങ്ങൾ</Link>
                <Link to="page-theyyam" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}>തെയ്യം</Link>
                <Link to="page6" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}>കമ്മിറ്റി</Link>
                <Link to="page7" onClick={toggleMobileMenu} smooth={true} duration={500} style={{cursor: 'pointer'}}><i className="fas fa-images"></i></Link>
                <a href="whatsapp://send?phone=919876543210" aria-label="WhatsApp">
    <i className="fab fa-whatsapp"></i>
</a>   
            </nav>
        </div>      
    </>
);

export default Header;